const state = {
    placeInfo: {},
  }
  
  const mutations = {
    SET_PLACEINFO: (state, placeInfo) => {
      state.placeInfo = placeInfo
      sessionStorage.setItem('placeInfo', JSON.stringify(placeInfo))
    },
  }
  
  const actions = {
   
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  